<template>
  <div class="d-flex">
    <!--  LEFT SIDE  -->
    <div
      class="ml-3 mr-3"
      style="display: grid; grid-template-columns: repeat(2, 1fr); grid-template-rows: repeat(1, 1fr); grid-gap: 0.5rem; width: 500px;"
    >
      <b-form-group label="Roles" style="grid-column: 1/6">
        <b-form-checkbox-group v-model="selectedRoles" stacked>
          <!--  selectedRoles  -->
          <b-form-checkbox
            v-for="companyRole in companyRoles"
            :key="companyRole.id"
            :value="companyRole.id"
            size="sm"
          >{{ companyRole.companyRole }}</b-form-checkbox>
          <b-form-invalid-feedback
            :state="$v.selectedRoles.$error ? $v.selectedRoles.length === 0 : null"
          >Please select at least one role.</b-form-invalid-feedback>
        </b-form-checkbox-group>
      </b-form-group>

      <div style="grid-column: 1/6;">
        <!--  Rating  -->
        <star-rating v-model="copy.rating" :star-size="20" :increment="0.5"></star-rating>

        <div style="padding-top:10px;cursor:pointer;margin-bottom:20px;color: blue; 0.7rem;">
          <a @click="copy.rating = 0;">Reset Rating</a>
        </div>
      </div>
    </div>

    <!--  MIDDLE: COMPANY INFO -->
    <!--  company  -->
    <div
      class="ml-3 mr-3"
      style="display: grid; grid-template-columns: repeat(6, 1fr); grid-template-rows: repeat(10, 40px); grid-gap: 0.5rem; width: 1200px;"
    >
      <b-form-group label="Number">
        <b-form-input disabled v-model="copy.number"></b-form-input>
      </b-form-group>

      <b-form-group label="Short Name *">
        <b-form-input
          :state="$v.copy.shortName.$error ? $v.copy.shortName.required : null"
          v-model="copy.shortName"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Name *" style="grid-column: 3/6">
        <b-form-input
          :state="$v.copy.companyName.$error ? $v.copy.companyName.required : null"
          v-model="copy.companyName"
          aria-required="10px"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Location Name *" style="grid-column: 1/6">
        <b-form-input
          :state="$v.copy.locationName.$error ? $v.copy.locationName.required : null"
          v-model="copy.locationName"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Address 1 *" style="grid-column: 1/3">
        <b-form-input
          :state="$v.copy.physicalAddress1.$error ? $v.copy.physicalAddress1.required : null"
          v-model="copy.physicalAddress1"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Address 2" style="grid-column: 3/6">
        <b-form-input v-model="copy.physicalAddress2"></b-form-input>
      </b-form-group>

      <b-form-group label="City *" style="grid-column: 1/3">
        <b-form-input
          :state="$v.copy.physicalCity.$error ? $v.copy.physicalCity.required : null"
          v-model="copy.physicalCity"
        ></b-form-input>
      </b-form-group>
      <!-- State -->
      <b-form-group style="grid-column : 1/3" label="State *">
        <b-form-select
          :state="$v.copy.physicalState.$error ? $v.copy.physicalState.required : null"
          v-model="copy.physicalState"
        >
          <template v-slot:first>
            <option :value="null" disabled>-- Select state --</option>
          </template>
          <option v-for="state in states" :key="state.abbr" :value="state.abbr">{{ state.name }}</option>
        </b-form-select>
      </b-form-group>

      <b-form-group label="Zip Code *">
        <b-form-input
          v-mask="'#####-####'"
          placeholder="#####-####"
          :state="$v.copy.physicalZipcode.$error ? !$v.copy.physicalZipcode.$error : null"
          v-model="copy.physicalZipcode"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Website" style="grid-column: 1/3">
        <b-form-input v-model="copy.website"></b-form-input>
      </b-form-group>
      <!-- Timezone -->
      <b-form-group label="Timezone *" style="grid-column: 3/6">
        <b-form-select
          :state="$v.copy.timeZoneId.$error ? $v.copy.timeZoneId.required : null"
          v-model="copy.timeZoneId"
        >
          <template v-slot:first>
            <option :value="null" disabled>-- Select timezone --</option>
          </template>
          <option
            v-for="timeZone in timeZones"
            :key="timeZone.id"
            :value="timeZone.id"
          >{{ timeZone.name }}</option>
        </b-form-select>
      </b-form-group>

      <b-form-group label="Phone *" style="grid-column: 1">
        <b-form-input
          v-mask="'(###) ###-####'"
          placeholder="(###)###-####"
          :state="$v.copy.phone.$error ? $v.copy.phone.isValidPhone : null"
          v-model="copy.phone"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Fax">
        <b-form-input
          v-mask="'(###) ###-####'"
          :state="$v.copy.fax.$error ? !$v.copy.workFax.isValidFax : null"
          placeholder="(###)###-####"
          v-model="copy.fax"
        ></b-form-input>
      </b-form-group>

      <b-form-checkbox
        checked
        class="d-flex align-items-center"
        style="grid-column: 1/2"
        v-model="copy.isChannel"
      >Is Channel?</b-form-checkbox>

      <b-form-group label="Channel" style="grid-column: 3/6">
        <b-form-select v-model="copy.channelName">
          <option
            v-for="companyChannel in companyChannels"
            :key="companyChannel.name"
            :value="companyChannel.name"
          >{{ companyChannel.name }}</option>
        </b-form-select>
      </b-form-group>

      <b-form-group label="Parent Company" style="grid-column: 1/3">
        <b-form-select v-model="copy.parentCompanyId">
          <option
            v-for="parentCompany in parentCompanies"
            :key="parentCompany.id"
            :value="parentCompany.id"
          >{{ parentCompany.name }}</option>
        </b-form-select>
      </b-form-group>

      <b-form-group label="Scope" style="grid-column: 3/6">
        <b-form-input v-model="copy.scope"></b-form-input>
      </b-form-group>

      <b-form-group label="Attributes" style="grid-column: 1/6">
        <!--  selectedAttributes  -->
        <multiselect
          v-model="selectedAttributes"
          tag-placeholder="Add this as new value"
          placeholder="Search or add attribute"
          label="name"
          track-by="id"
          :options="companyAttributes"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
        ></multiselect>
        <!-- <pre class="language-json"><code>{{ selectedAttributes }}</code></pre> -->
        <!-- <pre class="language-json"><code>{{ company }}</code></pre> -->
      </b-form-group>
    </div>

    <!--  RIGHT: CONTACT INFO  -->
    <div
      v-if="companyId === 0"
      class="ml-3 mr-3"
      style="display: grid; grid-template-columns: repeat(4, 1fr); grid-template-rows: repeat(9, 40px); grid-gap: 0.5rem; width: auto;"
    >
      <b-form-group label="First Name *" style="grid-column: 1/2">
        <b-form-input
          :state="$v.copy.firstName.$error ? $v.copy.firstName.required : null"
          v-model="copy.firstName"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Last Name *">
        <b-form-input
          :state="$v.copy.lastName.$error ? $v.copy.lastName.required : null"
          v-model="copy.lastName"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Title" style="grid-column: 1/4">
        <b-form-input v-model="copy.workTitle"></b-form-input>
      </b-form-group>
      <b-form-group label="Department/Role" style="grid-column: 1/4">
        <b-form-input v-model="copy.workDepartment"></b-form-input>
      </b-form-group>
      <b-form-group label="Email *" style="grid-column: 1/4">
        <b-form-input
          :state="$v.copy.workEmail.$error ? !$v.copy.workEmail.$error : null"
          v-model="copy.workEmail"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Phone *" style="grid-column: 1/2">
        <b-form-input
          v-mask="'(###) ###-####'"
          placeholder="(###)###-####"
          :state="$v.copy.workPhone1.$error ? $v.copy.workPhone1.isValidPhone : null"
          v-model="copy.workPhone1"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Ext" style="grid-column: 2/3">
        <b-form-input v-model="copy.workPhone1Extn"></b-form-input>
      </b-form-group>
      <b-form-group label="Type" style="grid-column: 3/4">
        <b-form-select v-model="copy.workPhone1TypeId">
          <template v-slot:first>
            <option :value="null">Select</option>
          </template>
          <option
            v-for="phnType in phoneTypes"
            :key="phnType.id"
            :value="phnType.id"
          >{{ phnType.name }}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Fax *" style="grid-column: 1/2">
        <b-form-input
          v-mask="'(###) ###-####'"
          placeholder="(###)###-####"
          :state="$v.copy.workFax.$error ? !$v.copy.workFax.$error : null"
          v-model="copy.workFax"
        ></b-form-input>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapState, mapActions, mapGetters } from 'vuex';
import StarRating from 'vue-star-rating';
//import gridFields from './fields';
import Grid from '@/shared/components/Grid';
import {
  SEARCH_DEBOUNCE_TIME,
  REGEX,
  STATES,
  TIME_ZONES
} from '@/shared/constants';
import multiselect from 'vue-multiselect';
import StateSelector from '@/shared/components/StateSelector';
import TimeZoneSelector from '@/shared/components/TimeZoneSelector';
import { required, email, minLength } from 'vuelidate/lib/validators';

//?pageNumber=1&pageSize=10&sortBy=id&sortOrder=ASC&filters={'statusId':null,'dateFrom':null,'dateTo':null}
export default {
  components: {
    StarRating,
    Grid,
    multiselect,
    StateSelector,
    TimeZoneSelector
  },
  props: ['companyId', 'updateCompany'],
  data() {
    return {
      states: STATES,
      timeZones: TIME_ZONES,
      copy: {},
      selectedRoles: [],
      selectedAttributes: [],
      primaryContact: [],
      checkedRowItemIds: [],
      spObj: {
        vwDto: {
          // companyName: '',
          // shortName: '',
          // numberingPrefix: '',
          // scope: '',
          // website: '',
          // linkedin: '',
          // twitter: '',
          // facebook: '',
          // instagram: '',
          // taxEIN: '',
          // businessEntityType: 0,
          // stateOfIncorporation: '',
          // isDemo: false,
          // channelName: '',
          // id: 0,
          // dateCreated: '',
          // dateModified: '',
          // active: true,
          // physicalAddress1: '',
          // physicalAddress2: '',
          // physicalCity: '',
          // physicalState: '',
          // physicalZipcode: '',
          // email: '',
          // phone: '',
          // fax: '',
          // isVerified: false,
          // isChannel: false,
          // companyRolesAsText: '',
          // companyRolesAsIds: '',
          // companyChannel: '',
          // companyStatus: '',
          // firstName: '',
          // lastName: '',
          // fullName: '',
          // workTitle: '',
          // workDepartment: '',
          // workEmail: '',
          // workPhone1: '',
          // workPhone1Extn: '',
          // workPhone1TypeId: 0,
          // workFax: '',
          // parentCompanyId: 0,
          // parentCompanyShortName: '',
          // parentCompanyName: '',
          // notes: '',
          // rating: 0,
          // timeZone: 0,
        },
        selectedRoles: [],
        selectedAttributes: []
      },
      timeZones: TIME_ZONES
    };
  },
  watch: {
    selectedRoles(val) {
      this.spObj.selectedRoles = val;
    },
    selectedAttributes(val) {
      this.spObj.selectedAttributes = val;
    },
    company: {
      handler(val, oldVal) {
        console.log('Company Update!');
        Object.assign(this.copy, val);
      },
      deep: true
    },
    updateCompany(val) {
      // copy is copied from the incoming company object
      // then we assign it back to an empty vwDto object overwriting
      // any values with those found in the copy after modification in the form
      const nObj = Object.assign({}, this.spObj.vwDto, this.copy);
      this.spObj.vwDto = nObj;
      this.saveCompanyRecord(this.spObj);
    }
    // companyId: function (val) {
    //     alert(val);
    //     company = val;
    // }
  },
  computed: {
    ...mapGetters('companies', [
      'companies',
      // 'pageInfo',
      // 'sortBy',
      // 'sortOrder',
      // 'searchQuery',
      // 'selectedId',
      // 'filters',
      // 'dateRange',
      'companyById',
      'company'
    ]),
    ...mapState('companies', [
      'companies',
      'companyRoles',
      'companyAttributes',
      'companyStatusValues',
      'parentCompanies',
      'companyChannels',
      'saveResponse',
      'company'
    ]),
    ...mapState('account', ['phoneTypes'])
  },
  methods: {
    //...mapMutations()
    ...mapActions('companies', [
      'getCompanies',
      'getCompanyRoles',
      'getCompanyAttributes',
      'getCompanyStatusValues',
      'getParentCompanies',
      'getCompanyChannels',
      'getSubmittedBy',
      'getLocations',
      'get',
      'sortGrid',
      'getPage',
      'search',
      'clearFilters',
      'saveCompanyRecord'
    ]),
    ...mapActions('account', ['getLookupPhoneTypesData']),
    setFormValues() {
      if (this.companyId === 0) {
        this.copy = this.getFormObject();
      } else {
        this.copy = Object.assign({}, this.copy, this.company);
        // this.copy = this.company;
        if (this.company.companyRolesAsIds)
          this.selectedRoles = this.company.companyRolesAsIds.split(',');
        if (this.company.companyAttributesAsIds)
          this.selectedAttributes = this.company.companyAttributesAsIds.split(
            ','
          );
        var sa = this.selectedAttributes.map(Number);
        var ca = this.companyAttributes;
        var c2 = ca.filter(c => sa.includes(c.id));
        this.selectedAttributes = c2;
      }
    },

    getFormObject() {
      return { timeZoneId: null, physicalState: null, workPhone1TypeId: null };
    },

    onStateChange(val) {
      this.copy.physicalState = val.abbr;
    },

    onTimeZoneChange(val) {
      this.copy.timeZoneId = val.id;
    },

    onSaveCompanyRecord() {
      this.saveCompanyRecord(this.spObj);
    },

    onClear() {
      this.clearFilters;
      Object.keys(this.filters).forEach(filterName => {
        this.filters[filterName] = null;
      });
      this.search(this.filters);
    },

    onSearch: debounce(function() {
      this.search(this.filters);
    }, SEARCH_DEBOUNCE_TIME),

    clickEditGrid(company) {
      this.$router.push(`/companies/${company.id}`);
    },

    checkFaxValidity(fax) {
      if (!fax) {
        return true;
      }
      return REGEX.isFax.test(fax);
    }
  },

  validations() {
    if (this.companyId === 0)
      return {
        copy: {
          shortName: { required },
          companyName: { required },
          physicalAddress1: { required },
          physicalCity: { required },
          physicalZipcode: { required, minLength: minLength(5) },
          timeZoneId: { required },
          physicalState: { required },
          phone: {
            required,
            isValidPhone(phone) {
              if (!phone) {
                return false;
              }
              return REGEX.isPhone.test(phone);
            }
          },
          firstName: { required },
          lastName: { required },
          workEmail: { required, email },
          workPhone1: {
            required,
            isValidPhone(workPhone1) {
              if (!workPhone1) {
                return false;
              }
              return REGEX.isPhone.test(workPhone1);
            }
          },
          workFax: {
            required,
            isValidFax(workFax) {
              return this.checkFaxValidity(workFax);
            }
          },
          locationName: { required },
          physicalState: { required },
          timeZoneId: { required },
          fax: {
            isValidFax(fax) {
              return this.checkFaxValidity(fax);
            }
          }
        },
        selectedRoles: { required }
      };
    else {
      return {
        copy: {
          shortName: { required },
          companyName: { required },
          physicalAddress1: { required },
          physicalCity: { required },
          physicalZipcode: { required },
          physicalState: { required },
          timeZoneId: { required },
          locationName: { required },
          phone: {
            required,
            isValidPhone(phone) {
              if (!phone) {
                return false;
              }
              return REGEX.isPhone.test(phone);
            }
          },
          timeZoneId: { required },
          physicalState: { required },
          fax: {
            isValidFax(fax) {
              return this.checkFaxValidity(fax);
            }
          }
        },
        selectedRoles: { required }
      };
    }
  },
  async created() {
    // let loader = this.$loading.show();

    // await this.getCompanies();
    // await this.getCompanyRoles();
    // await this.getCompanyAttributes();
    // await this.getCompanyStatusValues();
    await this.getParentCompanies();
    await this.getCompanyChannels();
    await this.getLookupPhoneTypesData();
    // loader.hide();

    this.setFormValues();
  }
};
</script>

<style scoped>
.form-width-default {
  width: 200px;
}

.form-width-small {
  width: 70px;
}
</style>